export function shuffle<T>(array: T[], randomFn: () => number = Math.random): T[] {
    let shuffledArray = [...array];
    let len = array.length;

    for(let i = 0; i < len; i += 1) {
        let randomIndex = Math.floor(randomFn() * len);

        [shuffledArray[i], shuffledArray[randomIndex]] = [shuffledArray[randomIndex], shuffledArray[i]];
    }

    return shuffledArray;
}